var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "tagAddPopWrap",
    staticClass: "tagAddPopWrap",
    class: _vm.tagAddPopWrapViewBln ? 'active' : null,
    style: _vm.posStyle
  }, [_c('button', {
    staticClass: "addBtn",
    class: [_vm.openClass, _vm.tagOptionPopListViewBln ? 'spin' : null],
    on: {
      "click": _vm.tagListHandler
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }